var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#BBF7C8",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4697 21.0303C26.7626 21.3232 27.2374 21.3232 27.5303 21.0303C27.8232 20.7374 27.8232 20.2626 27.5303 19.9697L23.5303 15.9697C23.3839 15.8232 23.1919 15.75 23 15.75C22.8983 15.75 22.8013 15.7702 22.7129 15.8069C22.6245 15.8435 22.5416 15.8978 22.4697 15.9697L18.4697 19.9697C18.1768 20.2626 18.1768 20.7374 18.4697 21.0303C18.7626 21.3232 19.2374 21.3232 19.5303 21.0303L22.25 18.3107V28C22.25 28.4142 22.5858 28.75 23 28.75C23.4142 28.75 23.75 28.4142 23.75 28V18.3107L26.4697 21.0303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollArrow);
export default __webpack_public_path__ + "static/media/ScrollArrow.ec1c2e78b2074504a15bc788f62d4e14.svg";
export { ForwardRef as ReactComponent };